import React from "react";
import Form from "react-bootstrap/Form";

const SwRadio = ({
  id,
  name,
  label,
  value,               // ✅ REQUIRED for proper radio behavior
  checked,
  defaultChecked,
  disabled = false,
  inline = false,
  onChange,
  className = "",
  ...rest
}) => {
  return (
    <Form.Check
      type="radio"
      id={id}
      name={name}
      label={label}
      value={value}        // ✅ MUST be forwarded
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      inline={inline}
      onChange={onChange}
      className={`SwRadio ${className}`.trim()}   // ✅ consistent with SW-UI pattern
      {...rest}
    />
  );
};

export default SwRadio;
